export const repositoryName = [
  {
    label: '视频',
    value: 5
  },
  {
    label: '音乐',
    value: 6
  },
  {
    label: '手指',
    value: 7
  },
  {
    label: '背景图',
    value: 8
  },
  {
    label: 'CTA按钮',
    value: 9
  },
  {
    label: '特效',
    value: 10
  },
  {
    label: '主角',
    value: 11
  },
  {
    label: '文案',
    value: 12
  },
  {
    label: '图片',
    value: 13
  },
  // {
  //   label: '特效',
  //   value: 14
  // },
  {
    label: '对话框',
    value: 14
  },
  {
    label: '音效',
    value: 15
  },
  {
    label: '模板',
    value: 16
  },
  {
    label: '进度条',
    value: 17
  },
  {
    label: '动画预设',
    value: 18
  },
  // 前端定义类型
  {
    label: '字体',
    value: 19
  }
]

export const cat2Options = [
  {
    label: '操作特效',
    value: 1
  },
  {
    label: '展示特效',
    value: 2
  }
]

export const cat1Options = [
  {
    label: '龙骨',
    value: 1
  },
  {
    label: '序列帧',
    value: 2
  },
  {
    label: '图片',
    value: 3
  }
]
export const cat1OptionsParticle = [
  {
    label: '龙骨',
    value: 1
  },
  {
    label: '序列帧',
    value: 2
  },
  {
    label: '粒子',
    value: 3
  }
]
